import React from 'react'
import { Link } from 'react-router'
import Container from 'muicss/lib/react/container'
import Header from './Header'
import Footer from './Footer'
import _ from 'lodash'
import util from '../util'

const App = ({ children, params }) => {
  const featureId = _.get(params, 'featureId')
  const disableHeaderLink = featureId && util.isStandaloneFeature(featureId)
  console.log(disableHeaderLink);
  return (
    <div>
        <Header disableLink={disableHeaderLink} />
        <div id="content-wrapper">
            <div className="mui--appbar-height"></div>
            {children}
        </div>
        <Footer />
    </div>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js